import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import modalSlice from "./reducers/modal.slice";
import filterSlice from "./reducers/filter.slice";
import alertSlice from "./reducers/alert.slice";
import shareSlice from "./reducers/share.slice";
export const store = configureStore({
  reducer: {
    modal: modalSlice,
    filter: filterSlice,
    alert: alertSlice,
    share: shareSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
